import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSurveyInstruction = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 412,
	height: 141,
	viewBox: "0 0 412 141",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M44.0426 97.1726C43.8326 97.1826 43.6226 97.1327 43.4326 97.0027C42.9826 96.6927 42.8626 96.0826 43.1726 95.6326L48.9326 87.1926C49.1026 86.9426 49.3826 86.7826 49.6826 86.7626C49.9626 86.7326 50.2826 86.8627 50.4826 87.0827L54.2026 91.1726L60.8726 80.1326C61.0326 79.8726 61.2926 79.7026 61.5926 79.6626C61.8926 79.6326 62.1926 79.7326 62.4126 79.9426L66.4626 83.9727L75.0126 71.4326C75.3226 70.9826 75.9326 70.8626 76.3826 71.1726C76.8326 71.4826 76.9527 72.0926 76.6427 72.5426L67.4326 86.0626C67.2726 86.3026 67.0026 86.4627 66.7126 86.4927C66.4026 86.5327 66.1326 86.4127 65.9226 86.2127L61.9226 82.2327L55.2226 93.3327C55.0626 93.6027 54.7826 93.7726 54.4726 93.8026C54.1426 93.8426 53.8526 93.7127 53.6426 93.4827L49.8726 89.3427L44.8226 96.7527C44.6426 97.0127 44.3526 97.1626 44.0626 97.1826L44.0426 97.1726Z",
			fill: "#40C676"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 82.1012,
			y1: 31.4375,
			x2: 17.1012,
			y2: 46.4375,
			stroke: "#DBDEE6",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 95.2575,
			y1: 34.63,
			x2: 181.257,
			y2: 94.631,
			stroke: "#DBDEE6",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.99999 55.999C13.4183 55.999 17 52.4173 17 47.999C17 43.5807 13.4183 39.999 8.99999 39.999C4.58171 39.999 1 43.5807 1 47.999C1 52.4173 4.58171 55.999 8.99999 55.999Z",
			stroke: "#DBDEE6",
			strokeWidth: .91,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .9,
			d: "M8.99999 50.999C10.6568 50.999 12 49.6559 12 47.999C12 46.3422 10.6568 44.999 8.99999 44.999C7.34313 44.999 6 46.3422 6 47.999C6 49.6559 7.34313 50.999 8.99999 50.999Z",
			fill: "#BFDAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M90 37C94.4183 37 98 33.4183 98 29C98 24.5817 94.4183 21 90 21C85.5817 21 82 24.5817 82 29C82 33.4183 85.5817 37 90 37Z",
			stroke: "#DBDEE6",
			strokeWidth: .91,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .9,
			d: "M90 32C91.6569 32 93 30.6569 93 29C93 27.3431 91.6569 26 90 26C88.3431 26 87 27.3431 87 29C87 30.6569 88.3431 32 90 32Z",
			fill: "#BFDAF8"
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: -.45,
			x2: 74.3229,
			y2: -.45,
			transform: "matrix(-0.920735 -0.390189 -0.390189 0.920735 284.432 129)",
			stroke: "#DBDEE6",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: -.45,
			x2: 55.4437,
			y2: -.45,
			transform: "matrix(0.991998 0.126254 0.126254 -0.991998 340 63)",
			stroke: "#DBDEE6",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: -.45,
			x2: 64.0078,
			y2: -.45,
			transform: "matrix(0.484316 -0.874893 -0.874893 -0.484316 297 126)",
			stroke: "#DBDEE6",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M332 55C336.418 55 340 58.5817 340 63C340 67.4183 336.418 71 332 71C327.582 71 324 67.4183 324 63C324 58.5817 327.582 55 332 55Z",
			stroke: "#DBDEE6",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M332 60C333.657 60 335 61.3431 335 63C335 64.6569 333.657 66 332 66C330.343 66 329 64.6569 329 63C329 61.3431 330.343 60 332 60Z",
			fill: "#BFDAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M403 63C407.418 63 411 66.5817 411 71C411 75.4183 407.418 79 403 79C398.582 79 395 75.4183 395 71C395 66.5817 398.582 63 403 63Z",
			stroke: "#DBDEE6",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M403 68C404.657 68 406 69.3431 406 71C406 72.6569 404.657 74 403 74C401.343 74 400 72.6569 400 71C400 69.3431 401.343 68 403 68Z",
			fill: "#BFDAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M292 124C296.418 124 300 127.582 300 132C300 136.418 296.418 140 292 140C287.582 140 284 136.418 284 132C284 127.582 287.582 124 292 124Z",
			stroke: "#DBDEE6",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .9,
			d: "M292 129C293.657 129 295 130.343 295 132C295 133.657 293.657 135 292 135C290.343 135 289 133.657 289 132C289 130.343 290.343 129 292 129Z",
			fill: "#BFDAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M39.2999 18.65C39.2999 20.67 37.6699 22.3 35.6499 22.3C33.6299 22.3 32 20.67 32 18.65C32 16.63 33.6299 15 35.6499 15C37.6699 15 39.2999 16.63 39.2999 18.65Z",
			fill: "#006ADC"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M351.3 100.65C351.3 102.67 349.67 104.3 347.65 104.3C345.63 104.3 344 102.67 344 100.65C344 98.63 345.63 97 347.65 97C349.67 97 351.3 98.63 351.3 100.65Z",
			fill: "#006ADC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M347.043 21.01C346.833 21 346.623 21.0499 346.433 21.1799C345.983 21.4899 345.863 22.1 346.173 22.55L351.933 30.99C352.103 31.24 352.383 31.4001 352.683 31.4201C352.963 31.4501 353.283 31.32 353.483 31.1L357.203 27.01L363.873 38.0501C364.033 38.3101 364.293 38.48 364.593 38.52C364.893 38.55 365.193 38.45 365.413 38.24L369.463 34.21L370.5 33.1826C370.628 32.9243 370.593 32.36 370.433 32.12C370.273 31.88 370.003 31.7199 369.713 31.6899C369.403 31.6499 369.133 31.77 368.923 31.97L364.923 35.95L358.223 24.85C358.063 24.58 357.783 24.41 357.473 24.38C357.143 24.34 356.853 24.47 356.643 24.7L352.873 28.84L347.823 21.4299C347.643 21.1699 347.353 21.02 347.063 21L347.043 21.01Z",
			fill: "#40C676"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M152.409 120.14C139.739 115.281 139.333 105.963 143.021 96.2192",
			stroke: "#002E5F",
			strokeWidth: .763748,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M150.992 36.816C149.64 31.7706 152.634 26.5846 157.679 25.2327L229.328 6.03457C234.373 4.68268 239.559 7.67681 240.911 12.7222L266.68 108.894C268.032 113.939 265.038 119.125 259.993 120.477L188.344 139.675C183.299 141.027 178.113 138.033 176.761 132.988L150.992 36.816Z",
			fill: "#E9EBF0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M162.74 23.0753C162.74 18.1006 166.772 14.0677 171.747 14.0677L245.923 14.0677C250.898 14.0677 254.931 18.1005 254.931 23.0753L254.931 122.64C254.931 127.615 250.898 131.648 245.923 131.648L171.747 131.648C166.772 131.648 162.74 127.615 162.74 122.64L162.74 23.0753Z",
			fill: "white",
			stroke: "#D9DEEB",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M178.302 6.59179C179.886 1.61449 185.205 -1.13617 190.182 0.448015L260.865 22.9449C265.842 24.5291 268.593 29.8482 267.008 34.8255L236.811 129.7C235.227 134.678 229.908 137.428 224.931 135.844L154.249 113.347C149.271 111.763 146.521 106.444 148.105 101.467L178.302 6.59179Z",
			fill: "#002E5F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M203.75 4.7661C204.317 2.9846 206.221 2.00007 208.002 2.56709L246.71 14.8873C248.492 15.4543 249.476 17.3582 248.909 19.1397C248.342 20.9212 246.439 21.9057 244.657 21.3387L205.949 9.01848C204.167 8.45146 203.183 6.54761 203.75 4.7661Z",
			fill: "#002E5F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M232.196 10.267C231.345 12.9393 228.489 14.4161 225.817 13.5656C223.145 12.715 221.668 9.85925 222.519 7.187C223.369 4.51475 226.225 3.03795 228.897 3.88848C231.569 4.73901 233.046 7.59479 232.196 10.267Z",
			fill: "#002E5F"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 227.357,
			cy: 8.72677,
			r: 1.69257,
			transform: "rotate(17.6554 227.357 8.72677)",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M183.136 7.76929C183.928 5.28064 186.587 3.9053 189.076 4.6974L259.315 27.0534C261.804 27.8455 263.179 30.505 262.387 32.9937L231.981 128.526C231.189 131.015 228.529 132.39 226.041 131.598L155.801 109.242C153.313 108.45 151.937 105.79 152.729 103.302L183.136 7.76929Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M200.602 48.1661C199.184 52.6199 194.424 55.0812 189.971 53.6636C185.517 52.2461 183.056 47.4864 184.473 43.0327C185.891 38.5789 190.65 36.1176 195.104 37.5352C199.558 38.9527 202.019 43.7124 200.602 48.1661Z",
			fill: "#006ADC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M189.818 44.3528L191.511 47.2598L196.245 44.6222",
			stroke: "white",
			strokeWidth: .9,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 220.278,
			y1: 51.3509,
			x2: 208.369,
			y2: 47.5605,
			stroke: "#D9DEEB",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 227.274,
			y1: 58.8324,
			x2: 206.854,
			y2: 52.3331,
			stroke: "#D9DEEB",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M192.895 72.3607C191.478 76.8144 186.718 79.2758 182.264 77.8582C177.81 76.4407 175.349 71.681 176.767 67.2273C178.184 62.7735 182.944 60.3122 187.398 61.7297C191.851 63.1473 194.313 67.9069 192.895 72.3607Z",
			fill: "#006ADC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M182.111 68.5477L183.804 71.4546L188.538 68.8171",
			stroke: "white",
			strokeWidth: .9,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 212.575,
			y1: 75.5448,
			x2: 200.666,
			y2: 71.7544,
			stroke: "#D9DEEB",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 219.57,
			y1: 83.0269,
			x2: 199.151,
			y2: 76.5277,
			stroke: "#D9DEEB",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M185.422 95.9246C184.005 100.378 179.245 102.84 174.791 101.422C170.338 100.005 167.876 95.245 169.294 90.7912C170.712 86.3375 175.471 83.8762 179.925 85.2937C184.379 86.7113 186.84 91.4709 185.422 95.9246Z",
			fill: "#E9EBF0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M174.639 92.1116L176.331 95.0186L181.066 92.381",
			stroke: "white",
			strokeWidth: .9,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 204.878,
			y1: 99.7367,
			x2: 192.969,
			y2: 95.9463,
			stroke: "#D9DEEB",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 211.872,
			y1: 107.22,
			x2: 191.452,
			y2: 100.721,
			stroke: "#D9DEEB",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M245.41 39.8148L191.434 22.635",
			stroke: "#D9DEEB",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M270.574 41.0046L261.99 66.1772",
			stroke: "#002E5F",
			strokeWidth: .763748,
			strokeLinecap: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgSurveyInstruction);
export default ForwardRef;
